<template>
  <div>
    <CommonHeader :page="'Liste des articles'" />

    <b-container fluid style="padding-top: 20px;">
      <ProductsTable />
    </b-container>
   
  </div>
</template>
<script>
import CommonHeader from "@/components/CommonHeader";
import ProductsTable from './Tables/ProductsTable'
import { get, del } from "@/mixins/api";

export default {
  name: "listeproduit",
  components: {
    CommonHeader,
    ProductsTable
  }
};
</script>
<style lang="scss">
.next-btn,
.previous-btn {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  margin: 5px;
  &.disabled {
    cursor: not-allowed;
  }
}
// .btn-primary {
//     background-color: rgb(194, 181, 155);
//     border-color: rgb(194, 181, 155);
//   }
.next-btn {
  background: rgb(194, 181, 155);
  color: #fff;
}
.previous-btn {
  background: #d2e3ee;
  color: #212529;
}
.card-img {
  width: 200px;
  height: 200px;
}
.tt {
  font-weight: bold;
}
</style>
